let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("hLvb6")).then(() => parcelRequire('bpOU2'));